var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgGoogleColor = function SvgGoogleColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.164 12c0-.762.125-1.492.352-2.18L1.562 6.8A11.752 11.752 0 00.355 12c0 1.867.434 3.629 1.204 5.195l3.953-3.027A6.962 6.962 0 015.164 12",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.105 5.066a6.8 6.8 0 014.329 1.547L19.852 3.2C17.77 1.387 15.098.266 12.105.266 7.465.266 3.473 2.922 1.562 6.8l3.954 3.02a6.922 6.922 0 016.59-4.755",
    fill: "#eb4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.105 18.934a6.922 6.922 0 01-6.59-4.754L1.564 17.2a11.716 11.716 0 0010.542 6.534c2.868 0 5.602-1.02 7.657-2.925l-3.754-2.903c-1.059.668-2.39 1.028-3.903 1.028",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.324 12c0-.691-.11-1.441-.27-2.133H12.106v4.531h6.305c-.316 1.547-1.176 2.735-2.402 3.508l3.754 2.903c2.156-2 3.562-4.985 3.562-8.809",
    fill: "#4285f4"
  }))));
};
export default SvgGoogleColor;